module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_03.d6765dc2.png";